module.exports = __webpack_public_path__ + "img/wrktop.6166a648.png";